import React from 'react'

import RouteLayout from '../../RouteLayout'
import { Buttons, Form, Table } from './Components'
import Spinner from '../../common/Spinner'
import { useSelector } from 'react-redux'


export default function Performance () {

  const { loader, form, data } = useSelector(state => state.reports.performance)

  const hasData = !!(data?.rows && data.rows.length)

  return (
    <RouteLayout title={'Сведения об успеваемости и качестве учебы (форма №2/СВУ)'}>
      <Form form={form}/>
      <Buttons visible={hasData} data={data}/>
      {loader
        ? <Spinner />
        : <Table data={data}/>
      }
    </RouteLayout>
  )
}
